export const getPrevious = (items, item) => {
  const orderedItems = [...items].sort((a, b) => a.order - b.order);
  const itemIndex = orderedItems.findIndex((currentItem) => currentItem === item);
  const previousItem = orderedItems[itemIndex - 1];

  return previousItem
    ? items.find((currentItem) => currentItem.order === previousItem.order)
    : null;
};

export const getNext = (items, item) => {
  const orderedItems = [...items].sort((a, b) => a.order - b.order);
  const itemIndex = orderedItems.findIndex((currentItem) => currentItem === item);
  const nextItem = orderedItems[itemIndex + 1];

  return nextItem ? items.find((currentItem) => currentItem.order === nextItem.order) : null;
};

export const add = (items, item, columns) => [
  ...items,
  { ...item, width: (item.size / columns) * 100 },
];

export const remove = (items, item) => items.filter((currentItem) => currentItem.id !== item.id);

export const update = (items, item, columns) =>
  items.map((currentItem) =>
    currentItem.id === item.id
      ? { ...currentItem, ...item, width: (item.size / columns) * 100 }
      : currentItem,
  );

export const moveUp = (items, item) => {
  const previousItem = getPrevious(items, item);
  if (!previousItem) {
    return items;
  }

  const previousItemOrder = previousItem.order;

  previousItem.order = item.order;
  item.order = previousItemOrder;

  return [...items];
};

export const moveDown = (items, item) => {
  const nextItem = getNext(items, item);
  if (!nextItem) {
    return items;
  }

  const nextItemOrder = nextItem.order;

  nextItem.order = item.order;
  item.order = nextItemOrder;

  return [...items];
};

export const moveTop = (items, item) => {
  items.forEach(() => (items = moveUp(items, item)));
  return items;
};

export const moveBottom = (items, item) => {
  items.forEach(() => (items = moveDown(items, item)));
  return items;
};

export const moveTo = (items, target, destination) => {
  if (target.order === destination.order) {
    return items;
  }
  while (getNext(items, target) !== destination) {
    items = target.order < destination.order ? moveDown(items, target) : moveUp(items, target);
  }
  return items;
};

export const isFirst = (items, item) => {
  return !getPrevious(items, item);
};

export const isLast = (items, item) => {
  return !getNext(items, item);
};
